module.exports = (__webpack_require__("bricks/presentational-bricks:XuQu"))("nmnc");